export default __webpack_public_path__ + "static/media/atom.af5c20af.pdf";